<template>
  <div
    :class="{
      'activity-instructions-container': true,
      [instructions.class]: !!instructions.class
    }"
  >
    <audio-toggle-button :onInstructionsVoiced="onInstructionsVoiced"></audio-toggle-button>
    <h1 class="activity-instructions">
      {{ instructions.written }}
    </h1>
  </div>
</template>

<script>
import AudioToggleButton from '../buttons/AudioToggleButton';

export default {
  name: 'ActivityInstructions',
  components: { AudioToggleButton },
  props: {
    instructions: {
      type: Object,
      required: true
    },
    onInstructionsVoiced: {
      default: () => null,
      type: Function,
      required: false
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-instructions {
  display: inline-block;
  font-family: 'hwtfutura';
  font-size: 18px;
  left: 15px;
  margin: 0px 0px 0px 25px;
  position: relative;
  top: 10px;
  width: calc(100% - 40px);
  -webkit-font-smoothing: auto;

  &.white-bg {
    background-color: white;
    border-radius: 5px;
  }

  @media (max-width: 1099px) {
    width: calc(100% - 118px);
  }

  @media (max-width: 432px) {
    margin-bottom: 8px;
  }
}

.activity-instructions-container {
  min-height: 45px;

  button {
    position: absolute;
  }
}
</style>
